import { GlobalAxios } from "./../axios/axios-config";
import {
  INewTicketAutomationReceivedRulePreference,
  ITicketAutomationReceivedRulePreference,
} from "../models/ticket-aut-rec-rule-preference";

const TICKET_AUTOMATION_RECEIVED_RULE_PREFERENCE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/ticketAutomationReceivedRulePreference/";

export const createTicketAutomationReceivedRulePreference = (
  item: INewTicketAutomationReceivedRulePreference,
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULE_PREFERENCE_ROUTE,
    item,
  );
};

export const getTicketAutomationReceivedRulePreferenceById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedRulePreference>(
    TICKET_AUTOMATION_RECEIVED_RULE_PREFERENCE_ROUTE + id,
  );
};

export const updateTicketAutomationReceivedRulePreferenceById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedRulePreference;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULE_PREFERENCE_ROUTE + id,
    item,
  );
};
